import { useState, useEffect } from 'react';
import {
  getFaceImage,
  getSignatureImage,
  getDocumentImage,
  imageDataToBase64,
} from '@dicio/sdk-ocr-web-module';

export interface DocumentImages {
  face?:      string;
  front?:     string;
  back?:      string;
  signature?: string;
}

/**
 * Extrae y convierte a base64 las imágenes del resultado raw del escaneo.
 * Recibe `rawResult` (unknown) — el tipo concreto lo gestiona el SDK internamente.
 */
export function useDocumentImages(rawResult: unknown): DocumentImages {
  const [images, setImages] = useState<DocumentImages>({});

  useEffect(() => {
    if (!rawResult) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const raw = rawResult as any;

    const face      = getFaceImage(raw);
    const front     = getDocumentImage(raw, 'front');
    const back      = getDocumentImage(raw, 'back');
    const signature = getSignatureImage(raw);

    setImages({
      face:      face      ? imageDataToBase64(face)      : undefined,
      front:     front     ? imageDataToBase64(front)     : undefined,
      back:      back      ? imageDataToBase64(back)      : undefined,
      signature: signature ? imageDataToBase64(signature) : undefined,
    });
  }, [rawResult]);

  return images;
}
